.infoText {
  color: var(--body-text-arrows-400);
}

gz-dropdown {
  --form-field-input-width: 400px;
}

.toggle-subtitle {
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
}

#web-categories-exclusions-field {
  margin-top: calc(var(--spacer) * -2); // remove extra space
}

.second-title {
  font-size: var(--dialog-title-font-size);
  font-weight: 500;
}

.pl-0 {
  padding-left: 0px;
}
